var _path, _path2, _line, _path3, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 240,
    viewBox: "0 0 350 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.605 133.245C168.911 133.562 172.212 132.49 174.7 130.289C177.188 132.49 180.488 133.562 183.795 133.245C184.514 136.487 186.554 139.295 189.416 140.981C188.092 144.028 188.092 147.498 189.416 150.544C186.554 152.231 184.514 155.038 183.795 158.281C180.488 157.963 177.188 159.036 174.7 161.236C172.212 159.036 168.911 157.963 165.605 158.281C164.885 155.038 162.845 152.231 159.984 150.544C161.308 147.498 161.308 144.028 159.984 140.981C162.845 139.295 164.885 136.487 165.605 133.245ZM171.481 121.625C173.08 119.458 176.32 119.458 177.918 121.625L179.43 123.674C180.446 125.051 182.225 125.629 183.857 125.112L186.284 124.343C188.851 123.53 191.472 125.434 191.491 128.127L191.51 130.673C191.523 132.384 192.623 133.897 194.246 134.438L196.661 135.243C199.216 136.094 200.217 139.175 198.651 141.365L197.169 143.436C196.174 144.827 196.174 146.698 197.169 148.09L198.651 150.161C200.217 152.351 199.216 155.432 196.661 156.283L194.246 157.088C192.623 157.628 191.523 159.142 191.51 160.853L191.491 163.399C191.472 166.092 188.851 167.996 186.284 167.183L184.7 166.681V170.263V189.133V198.263L176.7 193.863L174.7 192.763L172.7 193.863L164.7 198.263V189.133V170.263V166.681L163.116 167.183C160.549 167.996 157.928 166.092 157.908 163.399L157.889 160.853C157.877 159.142 156.777 157.628 155.153 157.088L152.738 156.283C150.183 155.432 149.182 152.351 150.749 150.161L152.23 148.09C153.225 146.698 153.225 144.827 152.23 143.436L150.749 141.365C149.182 139.175 150.183 136.094 152.738 135.243L155.153 134.438C156.777 133.897 157.877 132.384 157.889 130.673L157.908 128.127C157.928 125.434 160.549 123.53 163.116 124.343L165.543 125.112C167.174 125.629 168.953 125.051 169.969 123.674L171.481 121.625ZM172.7 170.993V184.733L174.7 183.633L176.7 184.733V170.993C175.469 171.703 173.93 171.703 172.7 170.993Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 43H305C311.627 43 317 48.3726 317 55V140C317 146.627 311.627 152 305 152H199.194C199.287 153.719 198.259 155.422 196.462 156.02L194.046 156.825C192.612 157.302 191.587 158.539 191.359 160H305C316.046 160 325 151.046 325 140V55C325 43.9543 316.046 35 305 35H46C34.9543 35 26 43.9543 26 55V140C26 151.046 34.9543 160 46 160H157.641C157.413 158.539 156.388 157.302 154.954 156.825L152.538 156.02C150.741 155.422 149.713 153.719 149.806 152H46C39.3726 152 34 146.627 34 140V55C34 48.3726 39.3726 43 46 43Z",
    fill: "currentColor"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 53,
    y1: 66,
    x2: 212,
    y2: 66,
    stroke: "currentColor",
    strokeWidth: 8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M227 142L241.5 124L245.737 142L259.5 133.274L277 142L291 133.274L304.5 142",
    stroke: "currentColor",
    strokeWidth: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 53,
    y1: 94,
    x2: 258,
    y2: 94,
    stroke: "currentColor",
    strokeWidth: 8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 53,
    y1: 123,
    x2: 133,
    y2: 123,
    stroke: "currentColor",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.5fa89eaa509732c3467cb08c146d96e4.svg";
export { ForwardRef as ReactComponent };